/*
 * SMParts — Passform-Anzeige auf der Produktseite.
 *
 * Vergleicht das gespeicherte Bike mit den Passdaten des Produkts und
 * zeigt einen von vier Zustaenden.
 *
 * Grundregel: KEINE Daten heisst KEINE Aussage. Ein Produkt ohne Tags
 * zeigt "noch keine Angaben" — niemals "passt nicht". Waehrend die
 * Datenpflege laeuft, ist das der haeufigste Fall, und eine falsche
 * Absage kostet Umsatz mit Teilen, die sehr wohl passen.
 */
(function () {
  'use strict';

  /* Aus "690 SMC R" wird "690-smc-r" — dieselbe Schreibweise wie im Tag */
  function slug(s) {
    return (s || '')
      .toString()
      .toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /*
   * Wie genau trifft ein Eintrag?
   *
   * Nicht ob, sondern wie genau — das ist der Unterschied. Ein Tag
   * "fit:ktm:125-exc" sagt etwas ueber das Modell, aber nichts ueber
   * das Baujahr. Steht dann "Passt fuer dein Bike — KTM 125 EXC 2016"
   * auf dem Schirm, liest der Kunde eine Baujahr-Zusage, die in den
   * Daten nicht steht. Bei Stuntpegs ist das harmlos, bei einem
   * Bremsscheibenadapter kommt die Retoure mit "bei euch stand doch
   * passt".
   *
   * Darum gibt jeder Eintrag zurueck, wie weit er reicht, und die
   * Zeile sagt genau so viel. Kommt das Baujahr spaeter in die Daten,
   * wird die Zeile von selbst genauer — ohne Codeaenderung.
   */
  var GENAU = { NICHTS: 0, UNIVERSAL: 1, MARKE: 2, MODELL: 3, BAUJAHR: 4 };

  /* Modelle, die fuer die Passform geprueft wurden — siehe unten bei
     "passt nicht". Fehlt die Liste, sagt die Seite nie "passt nicht". */
  var REFERENZ = [];
  try {
    var refEl = document.querySelector('[data-smp-passform-referenz]');
    if (refEl) REFERENZ = JSON.parse(refEl.textContent) || [];
  } catch (e) {
    REFERENZ = [];
  }

  function guete(eintrag, bike) {
    if (!eintrag) return GENAU.NICHTS;
    if (eintrag === 'all' || eintrag === 'universal' || eintrag === 'zubehoer') return GENAU.UNIVERSAL;

    var teile = eintrag.split(':');
    var marke = teile[0];
    var modell = teile[1];
    var jahre = teile[2];

    if (marke !== slug(bike.marke)) return GENAU.NICHTS;
    if (!modell) return GENAU.MARKE;
    if (modell !== slug(bike.modell)) return GENAU.NICHTS;
    if (!jahre) return GENAU.MODELL;

    var spanne = jahre.split('-');
    var von = parseInt(spanne[0], 10);
    var bis = parseInt(spanne[1] !== undefined ? spanne[1] : spanne[0], 10);
    var jahr = parseInt(bike.baujahr, 10);
    /* Unleserliche Spanne: der Modelltreffer bleibt, das Jahr nicht. */
    if (isNaN(von) || isNaN(bis) || isNaN(jahr)) return GENAU.MODELL;
    return jahr >= von && jahr <= bis ? GENAU.BAUJAHR : GENAU.NICHTS;
  }

  function setup(root) {
    var kaesten = {
      ask:     root.querySelector('[data-smp-fit-ask]'),
      yes:     root.querySelector('[data-smp-fit-yes]'),
      no:      root.querySelector('[data-smp-fit-no]'),
      unknown: root.querySelector('[data-smp-fit-unknown]')
    };

    var eintraege = (root.getAttribute('data-fitment') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    /*
     * stufe sagt, wie genau der Treffer war; nur der Ja-Kasten wertet
     * sie aus. Bei "passt nicht" und "noch nicht hinterlegt" nennen
     * wir das Bike vollstaendig — da ist es keine Zusage, sondern nur
     * die Auskunft, worauf sich die Aussage bezieht.
     */
    function zeige(name, bike, stufe) {
      Object.keys(kaesten).forEach(function (k) {
        if (kaesten[k]) kaesten[k].hidden = k !== name;
      });

      /* "Bike ändern" steht unter dem Kasten — ausser im Zustand
         "ohne Bike", wo der Waehler schon im Kasten steckt. */
      var unten = root.querySelector('[data-smp-fit-unten]');
      if (unten) unten.hidden = name === 'ask';
      if (!bike || !kaesten[name]) return;

      var titel = null;
      var label = [bike.marke, bike.modell, bike.baujahr].filter(Boolean).join(' · ');

      if (name === 'yes') {
        if (stufe === GENAU.UNIVERSAL) {
          titel = 'Universell einsetzbar';
          label = '';
        } else if (stufe === GENAU.MARKE) {
          titel = 'Passt auf ' + bike.marke;
          label = '';
        } else if (stufe === GENAU.MODELL) {
          /* Modell bestaetigt, Baujahr nicht — also ohne Baujahr. */
          titel = 'Passt auf dein Bike';
          label = [bike.marke, bike.modell].filter(Boolean).join(' · ');
        } else {
          titel = 'Passt auf dein Bike';
        }
      }

      if (titel) {
        kaesten[name].querySelectorAll('[data-smp-fit-titel]').forEach(function (el) {
          el.textContent = titel;
        });
      }
      kaesten[name].querySelectorAll('[data-smp-fit-bike]').forEach(function (el) {
        el.textContent = label;
        el.hidden = label === '';
      });

      whatsapp(kaesten[name], bike);
    }

    /*
     * Die Frage schreibt sich selbst.
     *
     * Wer auf WhatsApp landet und erst tippen muss, welches Teil und
     * welches Motorrad er meint, schreibt oft gar nicht. Beides steht
     * hier ohnehin herum, also steht es gleich in der Nachricht.
     */
    function whatsapp(kasten, bike) {
      var nummer = root.getAttribute('data-smp-wa');
      if (!nummer) return;

      var produkt = root.getAttribute('data-smp-wa-produkt') || '';
      var welches = bike
        ? [bike.marke, bike.modell, bike.baujahr].filter(Boolean).join(' ')
        : '';
      var text = 'Hallo! Passt "' + produkt + '" auf meine ' + welches + '?';

      kasten.querySelectorAll('[data-smp-fit-wa]').forEach(function (a) {
        a.href = 'https://wa.me/' + nummer + '?text=' + encodeURIComponent(text);
      });
    }

    function pruefe() {
      var bike = window.SMPBike ? window.SMPBike.read() : null;

      if (!bike) return zeige('ask');
      if (!eintraege.length) return zeige('unknown', bike);

      /* Der genaueste Treffer gewinnt: hat ein Produkt sowohl
         "fit:ktm" als auch "fit:ktm:125-exc:2014-2016", soll die Zeile
         die praezisere Aussage machen. */
      /* Hat das Produkt fuer dieses Modell eine Baujahr-Spanne, gilt nur
         die. Die Angabe ohne Jahr steht dann nur dabei, damit der Filter
         in Kollektionen (Tag im Pfad, ohne Jahr) das Teil ueberhaupt
         findet — siehe smp-bikefilter.js. */
      var modellSchluessel = slug(bike.marke) + ':' + slug(bike.modell);
      var mitJahr = eintraege.some(function (e) { return e.indexOf(modellSchluessel + ':') === 0; });
      var gueltig = mitJahr
        ? eintraege.filter(function (e) { return e !== modellSchluessel; })
        : eintraege;

      var beste = GENAU.NICHTS;
      gueltig.forEach(function (e) {
        var g = guete(e, bike);
        if (g > beste) beste = g;
      });
      if (beste > GENAU.NICHTS) return zeige('yes', bike, beste);

      /*
       * Kein Treffer heisst nicht automatisch "passt nicht".
       *
       * Frueher reichte ein Tag derselben Marke. Das war zu grob: Andreas
       * hat 139 Modelle geprueft, der Waehler kennt 294. Ein Produkt mit
       * KTM-Tags haette einem KTM 450 SMR "passt nicht" gesagt, obwohl
       * diese 450 SMR nie jemand angeschaut hat.
       *
       * "Passt nicht" gibt es deshalb nur, wenn beides stimmt:
       *   - das Produkt ist geprueft (Tag bikefilter:geprueft), und
       *   - das Bike steht auf der Liste der geprueften Modelle
       *     (smp-passform-referenz.liquid).
       * Sonst bleibt es bei "noch nicht hinterlegt".
       */
      var geprueft = root.hasAttribute('data-smp-geprueft');
      var schluessel = slug(bike.marke) + ':' + slug(bike.modell);
      var bekannt = REFERENZ.indexOf(schluessel) !== -1;

      zeige(geprueft && bekannt ? 'no' : 'unknown', bike);
    }


    if (window.SMPBike) window.SMPBike.onChange(pruefe);
    pruefe();
  }

  function init() {
    document.querySelectorAll('[data-smp-fit]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
